export enum InboundCarrierStatus {
    New = 1,
    OnWay = 2,
    Finished = 3,
    Cancelled = 4,
}

export const enumLabel = (value?: InboundCarrierStatus) => {
    switch (value) {
        case InboundCarrierStatus.New:
            return 'Новый';
        case InboundCarrierStatus.OnWay:
            return 'В пути';
        case InboundCarrierStatus.Finished:
            return 'Завершен';
        case InboundCarrierStatus.Cancelled:
            return 'Отменен';
        default:
            return '';
    }
};
